<template>
  <w-sliding-popup class="admin-access-info-popup" ref="slidingPopup" title="관리자 접근 정보" width="500px">
    <div slot="content" style="height: 100%">
      <div style="height: 100%">
        <el-form :model="formData" ref="form" label-width="130px" label-position="top">
          <el-row>
            <el-form-item label="Telnet/SSH ID #1" prop="telnetuserId1">
              <el-input v-model="formData.telnetuserId1"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="Telnet/SSH Password #1" prop="telnetuserPw1">
              <el-input v-model="formData.telnetuserPw1" type="password"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="Telnet/SSH ID #2" prop="telnetuserId2">
              <el-input v-model="formData.telnetuserId2"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="Telnet/SSH Password #2" prop="telnetuserId1">
              <el-input v-model="formData.telnetuserPw2" type="password"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveClick" :disabled="loading">저장</el-button>
      <el-button size="large" @click="close" :disabled="loading">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { cloneDeep } from 'lodash';
import MapAPI from '@/api/topologymap/common';
import msgUtil from '@/utils/message';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';

export default {
  name: 'WAdminAccessInfoPopup',
  components: {},
  data() {
    return {
      formData: {},
      formDataDefault: {
        objId: undefined,
        telnetuserId1: undefined,
        telnetuserPw1: undefined,
        telnetuserId2: undefined,
        telnetuserPw2: undefined,
      },
      loading: false,
    };
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open(params) {
      this.$refs.slidingPopup.open();
      this.formData = cloneDeep(this.formDataDefault);
      this.formData = params;
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    onSaveClick() {
      const encryptTargetData = createEncryptTargetData(this.formData, ['telnetuserPw1', 'telnetuserPw2']);
      if (encryptTargetData !== null) {
        getRsaEncrypt(encryptTargetData)
          .then((encryptData) => {
            const { telnetuserId1, telnetuserPw1, telnetuserId2, telnetuserPw2 } = encryptData;
            this.updateAdminAccessInfo(this.formData.objId, telnetuserId1, telnetuserPw1, telnetuserId2, telnetuserPw2);
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData('수정', '관리자 접근 정보', false));
            throw new Error(e);
          });
      } else {
        const { objId, telnetuserId1, telnetuserPw1, telnetuserId2, telnetuserPw2 } = this.formData;
        this.updateAdminAccessInfo(objId, telnetuserId1, telnetuserPw1, telnetuserId2, telnetuserPw2);
      }
    },
    /**
     * 관리자 접근 정보 팝업에서 텔넷 정보를 업데이트 한다.
     * @author Ju
     * @param  {[type]} objId         [description]
     * @param  {[type]} telnetuserId1 [description]
     * @param  {[type]} telnetuserPw1 [description]
     * @param  {[type]} telnetuserId2 [description]
     * @param  {[type]} telnetuserPw2 [description]
     * @return {[type]}               [description]
     */
    updateAdminAccessInfo(objId, telnetuserId1, telnetuserPw1, telnetuserId2, telnetuserPw2) {
      this.loading = true;
      MapAPI.updateAdminAccessInfo(objId, telnetuserId1, telnetuserPw1, telnetuserId2, telnetuserPw2).then((response) => {
        this.loading = false;
        let flag = false;
        if (response.data.success) {
          flag = true;
          this.close();
        }
        this.$message(msgUtil.getResultMsgData('수정', '관리자 접근 정보', flag));
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/AdminAccessInfoPopup.vue